import React from "react";
import ApiServiceFecth from "service/ApiServiceFecth";
import { RequestExceptionFactory } from "exceptions";
import PropTypes from "prop-types";
import HttpStatus from "http-status-codes";
import useAuth from "hooks/useAuth";

const withApi = (WrappedComponent) =>
  React.memo((props) => {
    const { clearSession } = useAuth();

    const resolveFunc = async (type, data) => {
      let response;
      switch (type) {
        case "post":
          response = await ApiServiceFecth.post(data);
          break;
        case "postForm":
          response = await ApiServiceFecth.postFormData(data);
          break;
        case "putForm":
          response = await ApiServiceFecth.putFormData(data);
          break;
        case "put":
          response = await ApiServiceFecth.put(data);
          break;
        case "delete":
          response = await ApiServiceFecth.delete(data);
          break;
        case "patch":
          response = await ApiServiceFecth.patch(data);
          break;
        default:
          response = await ApiServiceFecth.get(data);
          break;
      }
      return response;
    };

    const doRequest = async (type, data) => {
      const initialResponse = await resolveFunc(type, data);
      if (initialResponse.ok) {
        if (initialResponse.status === HttpStatus.NO_CONTENT) {
          return null;
        }
        let resp = "";
        if (type === "getFile") {
          resp = initialResponse;
        } else {
          resp = await initialResponse.json();
        }
        return resp;
      }
      if (initialResponse.status === HttpStatus.UNAUTHORIZED) {
        clearSession();
      }
      throw await RequestExceptionFactory.fromHttpResponse(initialResponse);
    };

    const doGet = async (data) => doRequest("get", data);
    const doGetFile = async (data) => doRequest("getFile", data);
    const doPost = async (data) => doRequest("post", data);
    const doDelete = async (data) => doRequest("delete", data);
    const doPut = async (data) => doRequest("put", data);
    const doPostFormData = async (data) => doRequest("postForm", data);
    const doPutFormData = async (data) => doRequest("putForm", data);
    const doPatch = async (data) => doRequest("patch", data);

    return (
      <WrappedComponent
        doGet={doGet}
        doGetFile={doGetFile}
        doPost={doPost}
        doPut={doPut}
        doDelete={doDelete}
        doPatch={doPatch}
        doPostFormData={doPostFormData}
        doPutFormData={doPutFormData}
        {...props}
      />
    );
  });

export const propTypes = {
  doPost: PropTypes.func,
  doGet: PropTypes.func,
  doGetFile: PropTypes.func,
  doDelete: PropTypes.func,
  doPut: PropTypes.func,
  doPatch: PropTypes.func,
  doPostFormData: PropTypes.func,
  doPutFormData: PropTypes.func,
};

export default withApi;